/*---------------------------------------------------------------------------------------------
 *  Copyright (c) i-Bridge Systems Philippines Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
import {
  CardContainer,
  ProjectCard,
  ProjectModal,
  SuccessModal,
  ConfirmationModal,
} from '../index';
import { apiUrl } from '../../utilities/apiUrl';
import { useState } from 'react';

export const ViewAllProjects = (props) => {
  const projectData = props.projectData;
  const entryPerPage = 6;
  const [currentPage, setCurrentPage] = useState(1);
  const [slice, setSlice] = useState([0, entryPerPage]);

  const [selectedProj, setSelectedProj] = useState('');

  const [projName, setProjName] = useState('');
  const [projDesc, setProjDesc] = useState('');
  const [projHoursWorked, setProjHoursWorked] = useState('');
  const [projStatus, setProjStatus] = useState(true);
  const [addProjSuccessOpen, setAddProjSuccessOpen] = useState(false);

  const [viewModalOpen, setViewModalOpen] = useState(false);
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);
  const [successModalOpen, setSuccessModalOpen] = useState(false);
  const [isEdited, setIsEdited] = useState(true);

  // VIEW PROJECT HANDLER
  const handleViewProject = (index) => {
    const currentProj = projectData[index];
    setSelectedProj(currentProj._id);
    setProjName(currentProj.projecttitle);
    setProjDesc(currentProj.projectdesc);
    setProjHoursWorked(currentProj.hoursworked);
    setProjStatus(currentProj.active);
  };
  // PAGE CHANGE HANDLER
  const handlePageChange = (e, page) => {
    setCurrentPage(page);
    let currPage = page - 1;
    page === 1
      ? setSlice([0, entryPerPage])
      : setSlice([currPage * entryPerPage, page * entryPerPage]);
  };

  // DELETE PROJECT HANDLER
  const handleDeleteProject = () => {
    setViewModalOpen(false);
    fetch(apiUrl('/project/' + selectedProj), {
      method: 'DELETE',
      credentials: 'include',
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
          setConfirmModalOpen(false);
          setIsEdited(false);
          setSuccessModalOpen(true);
        } else {
          alert(data.message);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  // EDIT PROJECT HANDLER
  const handleSaveEditedProject = () => {
    fetch(apiUrl('/project/' + selectedProj), {
      method: 'PUT',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        deptid: '',
        projecttitle: projName,
        projectdesc: projDesc,
        hoursworked: projHoursWorked,
        active: projStatus,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
          setViewModalOpen(false);
          setIsEdited(true);
          setSuccessModalOpen(true);
        } else {
          alert(data.message);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const resetFields = () => {
    setSelectedProj('');
    setProjName('');
    setProjDesc('');
    setProjHoursWorked('');
    setProjStatus('');
  };

  return (
    <>
      <CardContainer
        length={projectData.length}
        entryPerPage={entryPerPage}
        pageCount={Math.floor(projectData.length / entryPerPage)}
        handlePageChange={handlePageChange}
        spacing={3}
      >
        {projectData.slice(slice[0], slice[1]).map((proj, index) => (
          <ProjectCard
            key={index}
            title={proj.projecttitle}
            hours={proj.hoursworked}
            active={proj.active ? 'Active' : 'Inactive'}
            activeColor={proj.active ? '#84D8C5' : '#d5615d'}
            desc={proj.projectdesc}
            onClick={() => {
              setViewModalOpen(true);
              handleViewProject(
                (index + entryPerPage) * (currentPage - 1) -
                  (currentPage - 2) * index
              );
            }}
          />
        ))}
      </CardContainer>

      <ProjectModal
        open={viewModalOpen}
        onClose={() => {
          setViewModalOpen(false);
        }}
        handleConfirmDelete={() => setConfirmModalOpen(true)}
        primaryClickHandler={handleSaveEditedProject}
        secondaryClickHandler={() => {
          setViewModalOpen(false);
        }}
        projname={projName}
        projdesc={projDesc}
        projhoursworked={projHoursWorked}
        projstatus={projStatus}
        projNameOnChange={(e) => setProjName(e.target.value)}
        projDescOnChange={(e) => setProjDesc(e.target.value)}
        projHoursWorkedOnChange={(e) => setProjHoursWorked(e.target.value)}
        projStatusOnChange={(e) => setProjStatus(e.target.value)}
      />

      <SuccessModal
        open={successModalOpen}
        onClose={() => {
          setSuccessModalOpen(false);
          resetFields();
          window.location.reload();
        }}
        close={() => {
          setSuccessModalOpen(false);
          resetFields();
          window.location.reload();
        }}
        desc={`You have successfully ${
          isEdited ? 'edited' : 'deleted'
        } ${projName} Project.`}
      />
      <ConfirmationModal
        open={confirmModalOpen}
        onClose={() => setConfirmModalOpen(false)}
        title="Delete Project"
        desc={`Are you sure you want to delete ${projName}?`}
        primaryClickHandler={handleDeleteProject}
        secondaryClickHandler={() => setConfirmModalOpen(false)}
        primaryBtnName="Delete"
        secondaryBtnName="Cancel"
        primaryStyle={{
          bgcolor: '#d5615d',
          border: '1px solid #d5615d',
          '&:hover': {
            bgcolor: 'rgb(173, 59, 55) !important',
            borderColor: 'rgb(173, 59, 55)',
          },
        }}
      />
    </>
  );
};
